/**
 * TanStack Query — singleton QueryClient for the shop.
 *
 * Stale times match P7 config:
 *   - products: 5 min (catalog changes are infrequent)
 *   - orders: 30 sec (customers expect near-real-time order updates)
 *   - cart validation: 0 (always fresh — prices drift)
 *
 * DevTools are injected in main.tsx (dev only) via conditional import.
 */
import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 min default
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
})

/** Stale time overrides by query key prefix */
export const STALE = {
  PRODUCTS: 5 * 60 * 1000,  // 5 min
  ORDERS: 30 * 1000,         // 30 sec
  CART: 0,                   // always fresh
} as const
